export type TBlockType =
  | 'unstyled'
  | 'ordered-list-item'
  | 'unordered-list-item'
  | 'header-one'
  | 'header-two'
  | 'header-three'
  | 'header-four'
  | 'header-five'
  | 'header-six';

export type TInlineStyle = 'BOLD' | 'ITALIC' | 'UNDERLINE' | 'STRIKETHROUGH' | 'CODE';

export type TMediaType =
  | 'link'
  | 'attachment'
  | 'inline-image'
  | 'inline-video'
  | 'cta-button'
  | 'quote'
  | 'divider'
  | 'table'
  | 'strikethrough';

export type TAdditionalType = 'personalize' | 'template';

export type TFontFamily =
  | 'Arial'
  | 'Helvetica'
  | 'Georgia'
  | 'Times New Roman'
  | 'Courier New'
  | 'Verdana'
  | 'Trebuchet MS';

export type TFontSize = '12px' | '14px' | '16px' | '18px' | '20px' | '24px' | '28px' | '32px';

export type TTextColor = string;

export type THighlightColor = string;

export type TTextAlign = 'left' | 'center' | 'right' | 'justify';

export type TIndentType = 'indent' | 'outdent';

export interface ImageEntityData {
  src: string;
  alt?: string;
  width?: number;
  height?: number;
  alignment?: 'left' | 'center' | 'right';
}

export interface VideoEntityData {
  src: string;
  poster?: string; // Optional thumbnail image
  width?: number;
  height?: number;
  alignment?: 'left' | 'center' | 'right';
  controls?: boolean;
  autoPlay?: boolean;
  muted?: boolean;
  loop?: boolean;
  previewName?: string; // Custom preview name for emails
}

export interface ButtonEntityData {
  text: string;
  url: string;
  style: 'primary' | 'secondary' | 'outline';
  size: 'small' | 'medium' | 'large';
}

export interface CTAButtonEntityData {
  text: string;
  url: string;
  backgroundColor: string;
  textColor: string;
  alignment: 'left' | 'center' | 'right';
}

export interface TableCellData {
  content: string;
  isHeader?: boolean;
}

export interface TableEntityData {
  rows: TableCellData[][];
  alignment: 'left' | 'center' | 'right';
  borderStyle: 'none' | 'solid' | 'dashed';
  headerRow: boolean;
  width?: string;
}

export interface DividerEntityData {
  style: 'solid' | 'dashed' | 'dotted';
  color: string;
  thickness: number;
  alignment: 'left' | 'center' | 'right';
  width?: string;
}
